import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "",
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || ""}`,
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage", // O "localStorage" si prefieres
        storeAuthStateInCookie: false,
    }
};
